import ChartsService from './Base';

class Posts extends ChartsService {
  constructor() {
    super('posts');
  }
}

export default new Posts();
